<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Consultas — Pagamentos: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        | ,
        strong  filtrar
        |  e
        strong  abrir
        |  um pagamento em
        strong  Consultas → Pagamentos
        | .

      .toast.toast-primary
        | Exige as permissões
        strong  Pagamentos → Listar
        |  e
        strong  Pagamentos → Exibir
        | .

      h5.h5 1. Abrir Pagamentos
      ol
        li Em
          strong  Consultas
          | , clique em
          strong  Pagamentos
          | .

      h5.h5 2. Filtrar
      p Critérios disponíveis:
      ol
        li
          strong  Pagamento inicial / final
          |  — período em que o pagamento foi feito.
        li
          strong  Com documento
          |  — restringe a pagamentos vinculados a documento (padrão) ou
          |  mostra todos.
        li
          strong  Documento
          |  e
          strong  Cadastro
          |  — pickers para refinar a busca.
        li Clique na
          strong  lupa
          |  para filtrar.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de Pagamentos em Consultas")

      h5.h5 3. Listagem
      p
        | A tabela mostra tipo de débito, parcela, data de pagamento,
        |  valor pago, cadastro e documento vinculado.
      ol
        li Use a paginação (há muitos registros).
        li Clique no ícone de
          strong  olho
          |  para abrir o detalhe.

      h5.h5 4. Exibir o pagamento
      ol
        li Abra um pagamento pela listagem.
        li Confira valores, datas, códigos e vínculos com
          strong  Cadastro
          | ,
          strong  Contribuinte
          |  e
          strong  Documento
          | .
        li Se houver documento, use
          strong  Ver Documento
          |  para abrir a tela do Doc.
      figure.manual-figure
        img(:src="imgShow" alt="Exibição de um pagamento")

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/24-consultas-pagamentos-lista.png"),
      imgShow: require("@/assets/manuais/24a-consultas-pagamentos-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
